import { Card } from "@vb/ui";
import type { Differentiator } from "../content/differentiators.js";

const ICON_MAP: Record<Differentiator["accent"], string> = {
  gold: "var(--gold-bright)",
  cyan: "var(--cyan)",
  green: "var(--green)",
  red: "var(--red)",
};

interface FeatureGridProps {
  features: Differentiator[];
}

export function FeatureGrid({ features }: FeatureGridProps) {
  return (
    <div
      style={{
        display: "grid",
        gap: 16,
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
      }}
    >
      {features.map((f) => (
        <Card key={f.title} style={{ display: "grid", gap: 10 }}>
          <span
            aria-hidden
            style={{
              width: 36,
              height: 36,
              borderRadius: 10,
              background: `${ICON_MAP[f.accent]}22`,
              border: `1px solid ${ICON_MAP[f.accent]}66`,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              color: ICON_MAP[f.accent],
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="9" />
              <path d="M8 12l3 3 5-6" />
            </svg>
          </span>
          <h3 style={{ margin: 0, fontSize: 16 }}>{f.title}</h3>
          <p style={{ margin: 0, fontSize: 13, color: "var(--fg-2)", lineHeight: 1.55 }}>
            {f.blurb}
          </p>
        </Card>
      ))}
    </div>
  );
}
